import React from 'react'
import PropTypes from 'prop-types'
import { SeDebugProvider } from './seDebug/SeDebugContext'
import SalesforceStatusReportInner from './SalesforceStatusReportInner'

const MIN_HEIGHT = '300px'

function SalesforceStatusReportRenderer ({ config, displayName }) {
  return (
    <SeDebugProvider config={config}>
      <div style={{ minHeight: MIN_HEIGHT }}>
        <SalesforceStatusReportInner config={config} displayName={displayName} />
      </div>
    </SeDebugProvider>
  )
}

SalesforceStatusReportRenderer.propTypes = {
  config: PropTypes.object,
  displayName: PropTypes.string
}

export default SalesforceStatusReportRenderer
